import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { Page, ToggleGroup, Tab, Breadcrumb, Crumb } from '@framework'
import { ApprovedCashDepositRequestsTable, PendingCashDepositRequestsTable, RejectedCashDepositRequestsTable } from '@components/Tables'

const TABLE_REJECTED = 'rejected'
const TABLE_PENDING = 'pending'
const TABLE_APPROVED = 'approved'

class CashDepositOverviewPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      page: TABLE_PENDING
    }
  }

  handleToggle (selected) {
    this.setState({
      page: selected
    })
  }

  renderSelectedPage () {
    switch(this.state.page) {
      case TABLE_PENDING:
        return <PendingCashDepositRequestsTable />
      case TABLE_APPROVED:
        return <ApprovedCashDepositRequestsTable />
      case TABLE_REJECTED:
        return <RejectedCashDepositRequestsTable />
      default:
    }
  }

  render () {
    return (
      <Page fluid paperWhite className='scope-cash-deposit-overview'>
        <Helmet title='OPS Admin: Cash Deposit Overview' />
        <Breadcrumb>
          <Crumb to='/manage/workspace'>Home</Crumb>
          <Crumb>Cash Deposit Overview</Crumb>
        </Breadcrumb>
        <ToggleGroup
          selected={this.state.page}
          onChange={(selected) => this.handleToggle(selected)}>
          <Tab value={TABLE_PENDING}>Pending Cash Deposit</Tab>
          <Tab value={TABLE_APPROVED}>Approved Cash Deposit</Tab>
          <Tab value={TABLE_REJECTED}>Rejected Cash Deposit</Tab>

        </ToggleGroup>
        {this.renderSelectedPage()}
      </Page>
    )
  }
}

export default CashDepositOverviewPage